export const TIPO_IMOVEL_URBANO = 'URBANO';
export const TIPO_IMOVEL_RURAL = 'RURAL';

export const tiposImovel = [
  { key: TIPO_IMOVEL_URBANO, value: TIPO_IMOVEL_URBANO, label: 'Urbano' },
  { key: TIPO_IMOVEL_RURAL, value: TIPO_IMOVEL_RURAL, label: 'Rural' }
];
